<template>
  <div>
    <p>
      <strong>Hours:</strong><br />
      Monday - Friday <br />
      7:30am-4:30pm EST
    </p>
    <p>
      <strong>Call Toll Free:</strong><br />
      1-800-759-1495
    </p>
    <p>
      <strong>Email:</strong><br />
      <a :class="`${linkClass}`" href="mailto:Support@adi.org">Support@adi.org</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "HelpBlock",
  props: {
      linkClass: String
  }
};
</script>
